var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSideHmi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.49991C12 5.77615 11.7762 5.99999 11.4999 5.99999C11.2238 5.99999 11 5.77615 11 5.49991C11 5.22384 11.2238 5 11.4999 5C11.7762 5 12 5.22384 12 5.49991Z",
    fill: "#407EDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.0001H14.25C14.6642 20.0001 15 19.6643 15 19.25C15 18.8358 14.6642 18.5 14.25 18.5H2.5C1.94772 18.5 1.5 18.0523 1.5 17.5V6C1.5 5.17157 2.17157 4.5 3 4.5H20C20.8284 4.5 21.5 5.17157 21.5 6V14.75C21.5 15.1642 21.8358 15.5 22.25 15.5C22.6642 15.5 23 15.1642 23 14.75V5.5C23 4.11929 21.8807 3 20.5 3H2.5C1.11929 3 0 4.11929 0 5.5V18.0001C0 19.1046 0.89543 20.0001 2 20.0001Z",
    fill: "#407EDB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 16H14.5C14.7761 16 15 16.2239 15 16.5C15 16.7761 14.7761 17 14.5 17H1V16Z",
    fill: "#407EDB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.745L19.2595 19.745L19.077 19.9015L16.6496 21.9823L16.6467 12.253L22.6467 19.745L19.5 19.745Z",
    stroke: "#407EDB",
    strokeWidth: 1.3
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSideHmi);
export default __webpack_public_path__ + "static/media/icon_side_hmi.e9cd3355db5f89bb129dc3a903b887bf.svg";
export { ForwardRef as ReactComponent };